import React, { FC } from 'react'
import { Button, Spinner } from 'react-bootstrap'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingButton: FC<any> = ({ isLoading, children, ...props }) => {
  return (
    <Button {...props}>
      {isLoading && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="spinner"
          style={{ marginRight: '.5rem', width: '1rem' }}
        />
      )}
      {children}
    </Button>
  )
}

export default LoadingButton
